<template>
  <svg
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" x="0px" y="0px"
      :width="width"
      viewBox="0 0 100 125" enable-background="new 0 0 100 100" xml:space="preserve" :fill="color">
    <g display="none"><rect x="0" y="0.015" display="inline" fill="#000000" width="100" height="100"/></g>
    <g><path d="M21.479,54.181L45.808,78.51c0.026,0.027,0.034,0.065,0.061,0.091c1.146,1.146,2.659,1.715,4.17,1.711   c1.511,0.004,3.023-0.564,4.17-1.711c0.027-0.027,0.034-0.064,0.061-0.091l24.329-24.329c2.285-2.285,2.285-6.024,0-8.308   s-6.024-2.285-8.308,0L50.039,66.123L29.788,45.872c-2.285-2.285-6.024-2.285-8.308,0S19.195,51.896,21.479,54.181z"/>
      <path
          d="M21.479,30.256l24.329,24.329c0.026,0.027,0.034,0.065,0.061,0.091c1.146,1.146,2.659,1.715,4.17,1.711   c1.511,0.004,3.023-0.564,4.17-1.711c0.027-0.027,0.034-0.064,0.061-0.091l24.329-24.329c2.285-2.285,2.285-6.024,0-8.308   s-6.024-2.285-8.308,0L50.039,42.199L29.788,21.948c-2.285-2.285-6.024-2.285-8.308,0S19.195,27.971,21.479,30.256z"/></g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>
